<template>
  <tr class="border-b-2 border-gray-50">
    <td
      class="border-t-0 px-6 align-middle border-l-0 border-r-0 text-xs whitespace-nowrap p-4"
    >
      {{ data.id }}
    </td>
    <td
      class="border-t-0 px-6 align-middle border-l-0 border-r-0 text-xs whitespace-nowrap p-4"
    >
      {{ data.name }}
    </td>
    <td
      class="border-t-0 px-6 align-middle border-l-0 border-r-0 text-xs whitespace-nowrap p-4 text-right"
    >
      <button
        @click="handleEdit(data.name)"
        v-if="exsitCategoryName.includes(data.name)"
        class="w-[80px] bg-amber-500 text-white active:bg-amber-600 font-bold uppercase text-xs px-4 py-2 rounded shadow hover:shadow-md outline-none focus:outline-none mr-1 ease-linear transition-all duration-150"
        type="button"
      >
        Edit
      </button>
      <button
        @click="handleCreate(data.name)"
        v-else
        class="w-[80px] bg-blue-500 text-white active:bg-blue-600 font-bold uppercase text-xs px-4 py-2 rounded shadow hover:shadow-md outline-none focus:outline-none mr-1 ease-linear transition-all duration-150"
        type="button"
      >
        create
      </button>
    </td>
  </tr>
</template>

<script>
export default {
  name: "CategoryInstanceTableRow",
  data() {
    return {};
  },
  props: {
    data: {
      type: Object,
      required: true
    },
    exsitCategoryName: {
      type: Array,
      required: true
    },
    handleEdit: {
      type: Function,
      required: true
    },
    handleCreate: {
      type: Function,
      required: true
    }
  }
};
</script>
